var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 9.10547C17.125 9.80859 16.5391 10.3945 15.875 10.3945H10.25V16.0195C10.25 16.6836 9.66406 17.2305 9 17.2305C8.29688 17.2305 7.75 16.6836 7.75 16.0195V10.3945H2.125C1.42188 10.3945 0.875 9.80859 0.875 9.10547C0.875 8.44141 1.42188 7.89453 2.125 7.89453H7.75V2.26953C7.75 1.56641 8.29688 0.980469 9 0.980469C9.66406 0.980469 10.25 1.56641 10.25 2.26953V7.89453H15.875C16.5391 7.85547 17.125 8.44141 17.125 9.10547Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.db11e64950b0fe0186c3999839919cc9.svg";
export { ForwardRef as ReactComponent };